import FieldConfig from "../../../../proto/field-config"
import Task from "../../../../../model2/task/task"
import FieldDate from "../../../../generic/datetime/date/date"
import {FIELD_CONDITIONS_DATE} from "../../../../conditions/date"

export default class FieldProjectMomentCreated extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-date-created'
        this.label      = 'Date created'

        this.conditionTypes = FIELD_CONDITIONS_DATE
    }

    canEdit(model:Task):boolean {
        return false
    }
}
